<p-panel styleClass="panel-shadow">
  <p-header>
    <div class="panel-header">Dates & Prices</div>
  </p-header>

  <div [class.ghost]="loadingJob">
    <div
      class="summary-box"
      style="border: 1px solid var(--container-border-color); padding: 10px; border-radius: 5px"
    >
      <div class="flex">
        <div class="flex-grow-1">
          <div class="header">Supplier Price</div>
          <div class="header ghost-fill">
            {{
              (job?.supplierPrice | currency : 'GBP' : 'symbol' : '1.2-2') || loadingOrBlank('N/A')
            }}
          </div>

          <div
            *ngIf="totalPremium(true) > 0"
            class="premium-line"
            (click)="showSupplierPremiums = !showSupplierPremiums; showCustomerPremiums = false"
          >
            <i class="fa fa-check check-green"></i> Inc.
            {{
              (totalPremium(true) | currency : 'GBP' : 'symbol' : '1.2-2') || loadingOrBlank('N/A')
            }}
            supplier premium
            <i class="fa fa-info-circle info-icon"></i>

            <div *ngIf="showSupplierPremiums" class="hover-tip">
              <div *ngFor="let pp of showPremiums(job, true)">
                {{ pp.premium | currency : 'GBP' : 'symbol' : '1.2-2' }} -
                {{ pp.pricePremiumCategory.categoryName }}
              </div>
            </div>
          </div>

          <div
            *ngIf="totalPremium(false) > 0"
            class="premium-line"
            (click)="showCustomerPremiums = !showCustomerPremiums; showSupplierPremiums = false"
          >
            <i class="fa fa-check check-green"></i> Inc.
            {{
              (totalPremium(false) | currency : 'GBP' : 'symbol' : '1.2-2') || loadingOrBlank('N/A')
            }}
            customer premium <i class="fa fa-info-circle info-icon"></i>
            <div *ngIf="showCustomerPremiums" class="hover-tip">
              <div *ngFor="let pp of showPremiums(job, false)">
                {{ pp.premium | currency : 'GBP' : 'symbol' : '1.2-2' }} -
                {{ pp.pricePremiumCategory.categoryName }}
              </div>
            </div>
          </div>

          <!--
          <div *ngIf="job?.pricePremiums.length > 0" style="margin-top: 10px;">
            <div *ngFor="let premium of job?.pricePremiums">
              <div style="display: inline-block; margin-right: 5px;">
                <i class="fa fa-check check-green"></i>
              </div>
              <span style="display: inline-block; min-width: 60px;">
              {{ (premium?.premium | currency : 'GBP' : 'symbol' : '1.2-2') }}
            </span>
              {{ premium.pricePremiumCategory.categoryName }}
            </div>
          </div>
          -->
        </div>
        <div class="flex-grow-1 text-right">
          <div *ngIf="job?.supplierId == null || job?.supplierId == 0" style="color: #1b852f">
            <div class="header">Current Price</div>
            <div class="header ghost-fill">
              {{ (job?.buyItNowPrice | currency : 'GBP' : 'symbol' : '1.2-2') || loadingOrBlank() }}
            </div>
            <div *ngIf="job?.buyItNowPriceOriginal != job?.buyItNowPrice">
              (originally
              {{
                (job?.buyItNowPriceOriginal | currency : 'GBP' : 'symbol' : '1.2-2') ||
                  loadingOrBlank()
              }})
            </div>
          </div>

          <div *ngIf="job?.supplierId">
            <div class="header">Original Price</div>
            <div class="header ghost-fill">
              {{
                (job?.buyItNowPriceOriginal | currency : 'GBP' : 'symbol' : '1.2-2') ||
                  loadingOrBlank()
              }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="price-detail py-2 ghost-values">
      <div class="flex-grow-1">
        <div class="header">Driver Type Prices</div>

        <div class="label-value">
          <div class="label">Self-Employed Driver:</div>
          <div class="value">TBA</div>
        </div>

        <div class="label-value">
          <div class="label">Contracted Driver:</div>
          <div class="value">TBA</div>
        </div>

        <div class="label-value">
          <div class="label">Backstop Driver:</div>
          <div class="value">TBA</div>
        </div>

        <div class="header mt-3">Price Details</div>

        <div class="label-value">
          <div class="label">Insurance Cost:</div>
          <div class="value">
            {{ (job?.insuranceCost | currency : 'GBP' : 'symbol' : '1.2-2') || loadingOrBlank() }}
          </div>
        </div>
      </div>

      <div class="flex-grow-1">
        <div class="header">Holding Timeline</div>
        <div class="label-value">
          <div class="label">Release{{ isJobHeld() ? '' : 'd' }} From Hold:</div>
          <div class="value">
            {{ job?.heldEndDate | datex : "ddd DD MMM 'YY HH:mm" }}
            <i
              *ngIf="isManualReleaseFromHoldBlocked"
              class="fa fa-lock releaseFromHeldBlockedIcon"
              pTooltip="You are unable to release this job from hold as it is within the final minutes of the hold period ending. The job will remain in hold until the hold period ends."
              tooltipPosition="right"
            ></i>
          </div>
        </div>

        <div class="header mt-3">Schedule</div>

        <div class="label-value">
          <div class="label">Collection Date:</div>
          <div class="value">
            {{ (job?.scheduledDate | datex : "ddd DD MMM 'YY") || loadingOrBlank() }}
          </div>
        </div>

        <div class="label-value">
          <div class="label">Delivery Date</div>
          <div class="value">
            {{ (job?.scheduledDate | datex : "ddd DD MMM 'YY") || loadingOrBlank() }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <p-footer class="no-rounded-top-border flex justify-content-between py-2">
    <div>
      <i *ngIf="grabStateChangeInProgress" class="fa fa-spin fa-2x fa-spinner"></i>
      <button
        *ngIf="
          organisationTypeId == 1 &&
          !job?.grabDisabled &&
          job?.supplierId == 0 &&
          !grabStateChangeInProgress
        "
        pButton
        (click)="disableGrab()"
        label="Disable Grab"
        class="ui-button-danger mb-2 btn-mobile-block"
      ></button>
      <button
        *ngIf="
          organisationTypeId == 1 &&
          job?.grabDisabled &&
          job?.supplierId == 0 &&
          !grabStateChangeInProgress
        "
        pButton
        (click)="enableGrab()"
        label="Enable Grab"
        class="ui-button-success mb-2 btn-mobile-block"
      ></button>
    </div>
    <div>
      <button
        pButton
        [disabled]="
          organisationTypeId != OrganisationTypeEnum.Engineius || !isJobHeld() || extendingHold
        "
        (click)="openExtendHold()"
        label="Extend Hold"
        class="ui-button-secondary mb-2 btn-mobile-block"
        pTooltip="Keep this job in hold for longer. It stays visible to Juno but hidden from Job search."
      ></button>
      <button
        pButton
        [disabled]="organisationTypeId != 1 || !isJobHeld() || isManualReleaseFromHoldBlocked"
        (click)="releaseFromHold()"
        label="Release From Hold"
        class="ui-button-secondary mb-2 btn-mobile-block"
        [pTooltip]="
          isManualReleaseFromHoldBlocked
            ? 'You are unable to release this job from hold as it is within the final minutes of the hold period ending. The job will remain in hold until the hold period ends.'
            : ''
        "
        [tooltipDisabled]="!isManualReleaseFromHoldBlocked"
      ></button>
      <button
        [disabled]="organisationTypeId != 1 || commonServices.isJobClosed(job) || loadingJob"
        pButton
        label="Change"
        class="ui-button-primary mb-2 btn-mobile-block"
        (click)="isShowChangeJobDetails = true"
      ></button>
      <button
        *ngIf="commonServices.canShowPriceDetails(job)"
        class="ui-button-secondary mb-2 btn-mobile-block"
        type="button"
        (click)="commonServices.goToPriceDetails(organisationTypeId, job)"
        label="Price Details"
        pButton
      ></button>
    </div>
  </p-footer>
</p-panel>

<app-change-job-details-dialog
  [jobId]="jobId"
  [isShowChangeJobDetails]="isShowChangeJobDetails"
  (dialogOpenChange)="dialogClosed()"
></app-change-job-details-dialog>

<p-dialog
  header="Extend Hold"
  [(visible)]="showExtendHold"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '400px' }"
>
  <div style="margin-bottom: 30px">
    This job is held until {{ job?.heldEndDate | datex : "ddd DD MMM 'YY HH:mm" }}. Choose a later
    release date and time.
  </div>

  <div style="display: flex; margin-bottom: 20px">
    <div class="flex-grow-1">Release Date &amp; Time</div>
    <div class="flex-shrink-1">
      <p-calendar
        appendTo="body"
        [showTime]="true"
        [showIcon]="true"
        name="extendHoldDate"
        styleClass="full-width-calendar"
        dateFormat="D d MM"
        hourFormat="24"
        [stepMinute]="30"
        [showSeconds]="false"
        [(ngModel)]="extendHoldDate"
        [minDate]="minExtendHoldDate"
        placeholder="Select Date &amp; Time"
      ></p-calendar>
    </div>
  </div>

  <div
    style="display: flex; justify-content: flex-end; border-top: 1px solid grey; padding-top: 12px"
  >
    <button
      type="button"
      pButton
      class="ui-button-tertiary"
      label="Cancel"
      (click)="showExtendHold = false"
    ></button>
    <button
      type="button"
      class="ui-button-primary"
      pButton
      [disabled]="extendingHold"
      (click)="doExtendHold()"
      label="Confirm Extension"
    ></button>
  </div>
</p-dialog>

<p-confirmDialog></p-confirmDialog>
